import { ntDiferenciais } from "@/mocks/newtechData";

export default function NTDiferenciais() {
  return (
    <section className="bg-[#f5f5f5] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-[#3FA7D6] font-bold text-sm uppercase tracking-widest mb-1">Por que nos escolher</p>
          <h2 className="font-rajdhani font-bold text-[#1B1F5E] text-4xl md:text-5xl">Nossos Diferenciais</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ntDiferenciais.map((item) => (
            <div key={item.id} className="bg-white rounded-lg p-7 border border-gray-100 hover:border-[#3FA7D6] transition-all group">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mb-5 group-hover:bg-[#1B1F5E] group-hover:text-white transition-all">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-rajdhani font-bold text-[#1B1F5E] text-lg mb-2">{item.title}</h3>
              <p className="text-[#666] text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
